import { http } from "./http";

async function getPeriod(resource, id) {
  const response = await http.post(`/${resource}/${id}`);
  return {
    id: response.data.Id,
    title: response.data.Title,
  };
}

async function getPeriods(resource) {
  const response = await http.get(`${resource}`);
  return response;
}
async function createPeriod(resource, entity) {
  const response = await http.post(`/${resource}`, entity);
  return response;
}

async function updatePeriod(resource, id, entity) {
  const response = await http.put(`/${resource}/${id}`, entity);
  return response;
}

async function deletePeriod(resource, id) {
  const response = await http.delete(`${resource}/${id}`);
  return response;
}

export { getPeriod, getPeriods, createPeriod, updatePeriod, deletePeriod };
